/**
 * Register a custom element once across webpack multi-entry bundles (`app` + `template.*`).
 * The same module graph can execute twice; a second `customElements.define` throws and
 * aborts the rest of that bundle (e.g. Swiper init). This helper is a no-op if the tag
 * is already registered.
 *
 * @param {string} tagName
 * @param {typeof HTMLElement} ElementClass
 * @param {ElementDefinitionOptions} [options]
 */
export default function registerCustomElement(tagName, ElementClass, options) {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, ElementClass, options);
  }
}